import React, { ReactElement } from "react";
import * as Type from "@interface/index";

const ScheduleViews = (props: any): ReactElement => {
  return <>{props.children}</>;
};

export default ScheduleViews;
